// extracted by mini-css-extract-plugin
export default {"normalXl2":"styles_normalXl2__KNrEV","normalXl":"styles_normalXl__AAUdy","normalLg":"styles_normalLg__vDir8","normalMd":"styles_normalMd__THqIO","normalSm":"styles_normalSm__Khji2"};